// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BumUyWynnBwVVl {
  display: flex;
  position: relative;
  box-sizing: content-box;
  align-items: flex-start;
  margin-right: var(--ds-space-negative-150, -12px);
  margin-left: var(--ds-space-negative-150, -12px);
  padding: var(--ds-space-300, 24px) var(--ds-space-150, 12px) var(--ds-space-100, 8px) var(--ds-space-200, 14px);
  background-image: linear-gradient(to bottom, var(--ds-background-brand-bold, #0c66e4) 0%, var(--ds-background-brand-bold, #0c66e4) 100%);
  background-repeat: no-repeat;
  background-size: 100% 82px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.QbKFvEmknXY3nA {
  flex: 1;
  min-width: 0;
  margin-top: var(--ds-space-100, 8px);
  margin-left: var(--ds-space-100, 8px);
}
.QDXahTVkKpJXC5 {
  margin-bottom: var(--ds-space-0, 0);
  overflow: hidden;
  color: var(--ds-text-inverse, #ffffff);
  font-size: 16px;
  font-weight: var(--ds-font-weight-medium, 500);
  text-overflow: ellipsis;
  white-space: nowrap;
}
.QDXahTVkKpJXC5::selection {
  background: var(--ds-background-inverse-subtle, #00000029);
}
.CAJZqz8SNvJXMv {
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-background-accent-blue-subtle, hsla(0, 0%, 100%, 0.3));
  width: 75%;
  height: 16px;
}
._5SVEiPn3iQOkrf {
  overflow: hidden;
  color: var(--ds-text-inverse, #ffffff);
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
  -webkit-user-select: none;
          user-select: none;
}
._5SVEiPn3iQOkrf::selection {
  background: var(--ds-background-inverse-subtle, #00000029);
}
.al70_YTaxAAHpz {
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-background-accent-blue-subtle, hsla(0, 0%, 100%, 0.3));
  width: 75%;
  height: 12px;
  margin-left: var(--ds-space-050, 4px);
}
.I5U8QZGc06uQdW {
  min-width: 88px;
  min-height: 88px;
}
`, ""]);
// Exports
export var cardTop = `BumUyWynnBwVVl`;
export var profileInfo = `QbKFvEmknXY3nA`;
export var fullName = `QDXahTVkKpJXC5`;
export var fullNameSkeleton = `CAJZqz8SNvJXMv`;
export var atName = `_5SVEiPn3iQOkrf`;
export var atNameSkeleton = `al70_YTaxAAHpz`;
export var avatar = `I5U8QZGc06uQdW`;
export default ___CSS_LOADER_EXPORT___;
